import { useEffect } from 'react';

export const VISIBLE_VIEWPORT_HEIGHT_VAR = '--sk-visible-viewport-height';
export const VISIBLE_VIEWPORT_TOP_VAR = '--sk-visible-viewport-top';

const COVERED_AREA_THRESHOLD_PX = 32;

let subscriberCount = 0;

function writeVars(height: number, top: number) {
  document.documentElement.style.setProperty(VISIBLE_VIEWPORT_HEIGHT_VAR, `${height}px`);
  document.documentElement.style.setProperty(VISIBLE_VIEWPORT_TOP_VAR, `${top}px`);
}

function clearVars() {
  document.documentElement.style.removeProperty(VISIBLE_VIEWPORT_HEIGHT_VAR);
  document.documentElement.style.removeProperty(VISIBLE_VIEWPORT_TOP_VAR);
}

export function syncVisibleViewportVars() {
  const viewport = window.visualViewport;
  if (viewport === null || viewport === undefined) return;

  const coveredArea = document.documentElement.clientHeight - viewport.height;
  if (coveredArea < COVERED_AREA_THRESHOLD_PX) {
    clearVars();
    return;
  }

  writeVars(viewport.height, viewport.offsetTop);
}

export function useVisibleViewportVars() {
  useEffect(() => {
    const viewport = window.visualViewport;
    if (viewport === null || viewport === undefined) return;

    subscriberCount += 1;
    syncVisibleViewportVars();
    if (subscriberCount === 1) {
      viewport.addEventListener('resize', syncVisibleViewportVars);
      viewport.addEventListener('scroll', syncVisibleViewportVars);
    }

    return () => {
      subscriberCount -= 1;
      if (subscriberCount > 0) return;
      viewport.removeEventListener('resize', syncVisibleViewportVars);
      viewport.removeEventListener('scroll', syncVisibleViewportVars);
      clearVars();
    };
  }, []);
}
